module.exports = __webpack_public_path__ + "static/img/图片18.ac643b57.png";